import React from 'react';
import c from 'classnames';

import { WysiwygField, Button } from '../../../components';

import './style.scss';

const ParagraphButton = ({ entity, className }) => {
  const orientation = entity.getIn(['field_orientation', 0, 'value']) || 'horizontal';

  return (
    <div className={c('Paragraph ParagraphButton', 'text-center', className)}>
      <h2 className="ParagraphButton__title">
        {entity.getIn(['field_title', 0, 'value'])}
      </h2>
      {entity.getIn(['field_text', 0, 'processed']) ? (
        <WysiwygField
          property="schema:text"
          className="ParagraphButton__text"
          html={entity.getIn(['field_text', 0, 'processed'])}
        />
      ) : null}

      {entity.get('field_link') ? (
        <div className={c('u-multiple-buttons', `u-multiple-buttons--${orientation}`, 'u-margin--top--5')}>
          {entity.get('field_link').map((field) => {
            return (
              <Button
                key={`link:${field.get('title')}`}
                href={field.get('alias') ? field.get('alias') : field.get('uri')}
              >
                {field.get('title')}
              </Button>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};

export default ParagraphButton;
